import { ViolationMessage } from '@app/lib/form/contracts/ViolationMessage';

export function isViolationMessage(value?: object): value is ViolationMessage {
    return value != null && 'message' in value && typeof value.message === 'string';
}
